import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
  styled
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import dayjs from 'dayjs';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

export const SocietyAssets = (isOnline) => {
  const [assets, setAssets] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [open_new, setOpen_new] = useState(false);
  const [edit_data, setEdit_data] = useState([]);
  const [edit_mode, setEdit_mode] = useState(false);
  const [asset_modal, setAsset_modal] = useState(false);
  const [asset_fill, setAsset_fill] = useState([]);
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const society_name = location.state && location.state.name;


  const deleteAsset = (id) => {
    toast.promise(
        api.get(`/dashboards/delete/society/asset/${id}`, {
            headers: {
            Authorization: "Bearer " + fetchToken(),
            },
        }),
        {
            loading: "Deleting Asset and it's Data...",
            success: (response) => {
                fetchAllData();
                return response.data
            },
            error: (error) => {
                console.log(error)

                return "An error occurred, Please refresh the page"
            }
        }
    )
  }

  const viewAsset = (row) => {
    setAsset_modal(true);
    setAsset_fill(row);
  }
  
  const closeAsset = () => {
    setAsset_modal(false);
    setAsset_fill([]);
  }



const editAsset = (row) => {
    setEdit_mode(true);
    setEdit_data(row)
    setOpen_new(true)
    formik.setFieldValue("asset_name", row.asset_name)
    formik.setFieldValue("asset_value", row.asset_value)
    formik.setFieldValue("asset_type", row.asset_type)
    formik.setFieldValue("description", row.description)
    formik.setFieldValue("depreciation_period", row.depreciation_period)
    formik.setFieldValue("asset_status", row.asset_status)
    formik.setFieldValue("user_assigned", row.user_assigned)
    formik.setFieldValue("asset_id", row.id)
  }

  const closeNew = () => {
    setOpen_new(false);
    formik.handleReset();
    setEdit_mode(false);
    setEdit_data([]);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const asset_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };


  const fetchAllData = () => {
    toast.promise(
        api.get(`/users/user/all/${society_id}`, {
            headers: {
            Authorization: "Bearer " + fetchToken(),
            },
        }),
        {
            loading: "Loading Data...",
            success: (response) => {
                setAllUsers(response.data);

                return 'Loaded Successfully'
            },
            error: (error) => {
                console.log(error)

                return "An error occurred, Please refresh the page"
            }
        }
    )
    
    toast.promise(
        api.get(`/dashboards/get/all/assets/${society_id}`, {
            headers: {
            Authorization: "Bearer " + fetchToken(),
            },
        }),
        {
            loading: "Loading Data...",
            success: (response) => {
                setAssets(response.data?.assets);

                return 'Loaded Successfully'
            },
            error: (error) => {
                console.log(error)

                return "An error occurred, Please refresh the page"
            }
        }
    )
    
  };

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
        formik.setFieldValue("asset_image", file);
    }
  };
  const handleDocChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
        formik.setFieldValue("asset_document", file);
    }
  };


  useEffect(() => {
      fetchAllData();
  }, []);

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  // Calculate years covered since acquisition
const calculateYearsCovered = (dateAcquired) => {
  const acquiredDate = new Date(dateAcquired);
  const currentDate = new Date();
  const diffTime = Math.abs(currentDate - acquiredDate);
  return Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365));
};

// Calculate current value of the asset
const calculateCurrentValue = (asset) => {
  if (!asset?.date_acquired || !asset?.asset_value || !asset?.depreciation_period) return 0;
  
  const yearsCovered = calculateYearsCovered(asset.date_acquired);
  const annualDepreciation = asset.asset_value / asset.depreciation_period;
  const totalDepreciation = annualDepreciation * yearsCovered;
  
  // Ensure value doesn't go below 0
  return Math.max(asset.asset_value - totalDepreciation, 0);
};

  const formik = useFormik({
    initialValues: {
        asset_name:"",
        asset_value: null,
        date_acquired: dayjs(),
        society_id: society_id,
        asset_type: "",
        description: "",
        depreciation_period: null,
        asset_status: "",
        user_assigned: null,
        asset_image: null,
        asset_document: null,
        asset_id: null,
    },
    onSubmit: (values) => {
      const newData = new FormData();
      newData.append("asset_name", values.asset_name);
      newData.append("asset_value", values.asset_value);
      newData.append("date_acquired", values.date_acquired);
      newData.append("society_id", values.society_id);
      newData.append("asset_type", values.asset_type);
      newData.append("description", values.description);
      newData.append("depreciation_period", values.depreciation_period);
      newData.append("asset_status", values.asset_status);
      newData.append("user_assigned", values.user_assigned);


      if (values.asset_image !== null) {
        newData.append("asset_image", values.asset_image);
      }
      if (values.asset_document !== null) {
        newData.append("asset_document", values.asset_document);
      }
      if (values.asset_id !== null) {
        newData.append("asset_id", values.asset_id);
      }

      toast.promise(
        api.post("/dashboards/save/new/asset", newData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: edit_mode?"Updating Asset...": "Registering New Asset... ",
          success: (response) => {
            closeNew();
            fetchAllData();

            return response.data;
          },
          error: (error) => {
            console.log(error);

            return "An error occurred, Please refresh.";
          },
        }
      );
    },
  });

  function formatDateToYearMonthDay(date) {
    const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
    } else if (day === 2 || day === 22) {
    suffix = "nd";
    } else if (day === 3 || day === 23) {
    suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
}

const currencyFormat = new Intl.NumberFormat('en-GH', {
  style: 'currency',
  currency: 'GHS',
});  

  function formatDateToYearMonth(date) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${year}`;
  }

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h3"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>Assets</b>
          </Typography>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h6"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>{society_name}</b>
          </Typography>
          <Box>
            <Button
              size="small"
              color="success"
              variant="contained"
              sx={{
                m: 3,
                borderRadius: 2,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={() => setOpen_new(true)}
            >
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Register new asset</b>
              </Typography>
            </Button>
          </Box>
          

          <Box
            sx={{
              overflow: "auto",
              marginBottom: 10,
              maxHeight: 340,
              "&::-webkit-scrollbar": {
                width: "7px",
                height: "7px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>No.</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Asset name</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Value</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>User assigned</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Type</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Status</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Update Asset</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>View Asset</b>
                    </Typography>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Delete Asset</b>
                    </Typography>{" "}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assets?.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                      backgroundColor: "#f5f3f4",
                    }}
                  >
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{index + 1}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{row.asset_name}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{currencyFormat.format(row.asset_value)}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{row.user_assigned_fullname}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{row.asset_type}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{row.asset_status}</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={() => editAsset(row)}
                        >
                          <EditRoundedIcon />
                        </Button>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={() => viewAsset(row)}
                        >
                          <FolderSharedRoundedIcon />
                        </Button>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <Button
                          size="small"
                          color="error"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={() => deleteAsset(row.id)}
                        >
                          <DeleteRoundedIcon />
                        </Button>
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          {/* table box end here */}
        </Box>

        <Modal
          open={open_new}
          onClose={closeNew}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid xs={12} md={12}>
                <Typography
                  sx={{ textAlign: "center" }}
                  variant="h3"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{edit_mode? "Update Asset": "Register New Asset"}</b>
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    required
                    name="asset_name"
                    type="text"
                    value={formik.values.asset_name}
                    onChange={formik.handleChange}
                    placeholder="Asset Name"
                    helperText="Asset Name"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="asset_value"
                    type="number"
                    inputProps={{ step: 'any' }}
                    value={formik.values.asset_value}
                    onChange={formik.handleChange}
                    placeholder="Purchase price"
                    helperText="Purchase price"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="date_acquired"
                    type="date"
                    value={formik.values.date_acquired}
                    onChange={formik.handleChange}
                    placeholder="Date Acquired"
                    helperText="Date Acquired"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="asset_type"
                    type="text"
                    value={formik.values.asset_type}
                    onChange={formik.handleChange}
                    placeholder="Asset type (vehicle, desk)..."
                    helperText="Asset type"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="depreciation_period"
                    type="number"
                    inputProps={{ step: 'any' }}
                    value={formik.values.depreciation_period}
                    onChange={formik.handleChange}
                    placeholder="Depreciation period (1, 2.5) NB: in years"
                    helperText="Depreciation period (in years)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="description"
                    type="text"
                    multiline
                    rows={4}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    placeholder="Description (model, product year, seller details...)"
                    helperText="Description (model, product year, seller details...)"
                    fullWidth
                  />
                {
                    edit_mode?
                    <Autocomplete
                    id="tags-outlined"
                    options={[
                      { id: "In Use", value: "In Use" },
                      { id: "In Repair", value: "In Repair" },
                      { id: "Expired", value: "Expired" },
                      { id: "Disposed", value: "Disposed" },
                      { id: "Not Ready", value: "Not Ready" },
                    ]}
                    sx={{ mt: 2 }}
                    getOptionLabel={(option) => option.value}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.id
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue("asset_status", value.id)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Status"
                        helperText="Status"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                  :null
                }
                
                
                <Autocomplete
                    id="tags-outlined"
                    options={allUsers}
                    sx={{ mt: 2 }}
                    getOptionLabel={(option) => option.username}
                    isOptionEqualToValue={(option, value) =>
                      option.username === value.id
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue("user_assigned", value.id)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Assign User"
                        helperText="Assign User"
                        size="small"
                        fullWidth
                      />
                    )}
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="asset_image"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    helperText="Photo of Asset"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="asset_document"
                    type="file"
                    accept="image/*"
                    onChange={handleDocChange}
                    placeholder="Asset Document (receipt, contract...)"
                    helperText="Asset Document (receipt, contract...)"
                    fullWidth
                  />
              </Grid>

              <Grid item xs={12} md={8}></Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={closeNew}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="small"
                    color="success"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={formik.handleSubmit}
                  >
                    {edit_mode?"Complete update":"Complete Registration"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={asset_modal}
          onClose={closeAsset}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
            <Box sx={asset_style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography variant="h3" sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Asset Details</b>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Item>
                        <Avatar sx={{ width: 150, height: 150, mx:'auto' }} src={pic(asset_fill?.asset_image ?asset_fill?.asset_image:null)} />
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Box>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Asset Name: {asset_fill?.asset_name}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Purchase Price: {asset_fill?.asset_value}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Date Acquired: {formatDateToYearMonthDay(new Date(asset_fill?.date_acquired))}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Depreciation period (Life span): {asset_fill?.depreciation_period} years</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Status: {asset_fill?.asset_status}</b>
                          </Typography>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>User Assigned: {asset_fill?.user_assigned_fullname}</b>
                          </Typography>
                        </Box>
                      </Item>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Item>
                        <Avatar sx={{ width: 150, height: 150, mx:'auto' }} src={pic(asset_fill?.asset_document ? asset_fill?.asset_document : null)} />
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                          <Box>
                            <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Asset's Current Value: </b>
                            </Typography>
                            <Divider sx={{ m:.5 }}/>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Depreciated percentage per year: <span style={{ color:'red' }}>{((1 / asset_fill?.depreciation_period) * 100).toFixed(2)}%</span></b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Depreciated amount per year: <span style={{ color:'red' }}>{currencyFormat.format(asset_fill?.asset_value / asset_fill?.depreciation_period)}</span></b>
                            </Typography>
                          </Box>
                          <Box>
                            <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Life Span</b>
                            </Typography>
                            <Divider sx={{ m:.5 }}/>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Years covered: <span style={{ color:'red' }}>{calculateYearsCovered(asset_fill?.date_acquired)}</span></b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Years left to expire: <span style={{ color:'blue' }}>{asset_fill?.depreciation_period - calculateYearsCovered(asset_fill?.date_acquired)}</span></b>
                            </Typography>
                          </Box>
                        </Box>
                        <Divider variant='middle' sx={{ m:1 }} />
                        <Typography sx={{ textAlign:'center', color:'green', my:10.5 }} variant="h1" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Value Difference: {currencyFormat.format(calculateCurrentValue(asset_fill))}</b>
                        </Typography>
                      </Item>
                    </Grid>

                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={closeAsset}
                    >
                      Close
                    </Button>
                    
                </Grid>
            </Box>
          </Modal>

      </main>
    </div>
  );
};
